import { useTranslation } from '../../i18n/i18n';
import { TRUST_CENTER_LINKS } from '../../data/trustCenterLinks';
import HostedVerIdLogo from './VerIdLogo';

/**
 * HostedFooter — "Powered by Ver.iD | Privacy policy" bar shown at the bottom
 * of both desktop (inside main content area) and mobile (below action buttons).
 *
 * Figma: Visible in all frames, e.g. https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=339-22201
 */
export default function HostedFooter() {
  const { t } = useTranslation();

  return (
    <div
      data-testid="footer"
      className="flex items-center justify-center gap-2 py-2"
    >
      <a
        href="https://ver.id"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-0.5"
      >
        <span className="text-xs text-[#a4a6a8] leading-normal">
          {t('footer.powered')}
        </span>
        <HostedVerIdLogo className="ml-1 text-[#a4a6a8]" />
      </a>
      <div className="h-[18px] w-px bg-[#a4a6a8]" />
      <a
        className="text-xs text-[#a4a6a8] leading-normal"
        href={TRUST_CENTER_LINKS.privacyPolicy}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('footer.privacyPolicy')}
      </a>
    </div>
  );
}
